import { DispatchEvent as ServerDispatchEvent } from 'server/models/DispatchEvent';

export { DispatchEventData, DispatchEventOptions } from 'server/models/DispatchEvent';

export class DispatchEvent extends ServerDispatchEvent {
    ApprovalOfCharges() {
        return this._approvalsOfCharges().length === 0 ? null : this._approvalsOfCharges()[0];
    }
}


// WEBPACK FOOTER //
// ./data/models/DispatchEvent.ts